import {catchError, filter, map, mergeMap, tap} from 'rxjs/operators';

import {ADistributeSchedule, AFetchSchedule, TRemote, TSchedule} from '../actions';
import {ofType} from 'redux-observable-es6-compat';
import {of} from 'rxjs';
import {Scheduler} from '../entities/Scheduler';

const schedulesListeners = [
  TSchedule.FETCH_SCHEDULE,
  TSchedule.FETCH_SCHEDULE_24,
  TRemote.SET_REMOTE,
  TSchedule.DUPLICATE_SCHEDULE,
  TSchedule.EDIT_SCHEDULE
];

let fetchSchedulesEpicTimeout = 0;

export const fetchSchedulesEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({type}) => schedulesListeners.filter(type => type !== TSchedule.DUPLICATE_SCHEDULE && type !== TSchedule.EDIT_SCHEDULE).includes(type)),
    filter(() => new Date().getTime() - fetchSchedulesEpicTimeout > 5000),
    tap( () => fetchSchedulesEpicTimeout = new Date().getTime()),
    mergeMap(() => restApi.get(`/schedule`)),
    map(({ id, schedule }) => ADistributeSchedule(new Scheduler(id, schedule))),
  );

export const duplicateOneDayEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TSchedule.DUPLICATE_SCHEDULE),
    mergeMap(({ payload }) => restApi.put(`/schedule/duplicate/${payload.configurationToDuplicateId}`, payload.configurationForm).pipe(
      catchError(() => of(AFetchSchedule())),
    ))
  );

export const editScheduleEpic = (action$, _, {restApi}) =>
  action$.pipe(
    ofType(TSchedule.EDIT_SCHEDULE),
    mergeMap(({payload}) => restApi.put(`/schedule/update`, payload).pipe(
      catchError(() => of(AFetchSchedule())),
    ))
  );
